import { mergeRefs } from "@react-aria/utils";
import cx from "classnames";
import { useMemo } from "react";

import { ChevronDown } from "components/icons/generated";
import Box from "ds/components/Box";
import { default as Button } from "ds/components/Button";
import DropdownMenu from "ds/components/DropdownMenu";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import Tooltip from "ds/components/Tooltip";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableCellText from "ds/components/Table/Row/CellText";
import {
  SharedModuleDataWithSpace,
  SharedModuleDataWithAccount,
} from "views/Account/SharedModulesNew/types";
import TableCellSpace from "ds/components/Table/Row/CellSpace";

import styles from "./styles.module.css";

const SharedModulesTableSharedToCell = ({
  item: sharedModule,
  ...cellProps
}: TableSimpleCellProps<SharedModuleDataWithSpace | SharedModuleDataWithAccount>) => {
  const items = useMemo(() => {
    return "space" in sharedModule ? sharedModule?.spaces || [] : [];
  }, [sharedModule]);

  if (items.length === 0) {
    return (
      <TableSimpleCell {...cellProps}>
        <TableCellText>This account</TableCellText>
      </TableSimpleCell>
    );
  }

  if (items.length === 1) {
    return (
      <TableSimpleCell {...cellProps}>
        <TableCellSpace href={`/spaces/${items[0].id}`}>{items[0].name}</TableCellSpace>
      </TableSimpleCell>
    );
  }

  const moreTagsTooltip = `${items.length} spaces`;

  return (
    <TableSimpleCell {...cellProps}>
      <Box fullWidth justify="start" align="center" gap="small">
        <DropdownMenu
          placement="bottom right"
          className={styles.settingsDropdownSection}
          triggerComponent={
            <Tooltip
              on={({ ref, ...tooltipProps }) => (
                <Button
                  {...tooltipProps}
                  ref={mergeRefs<HTMLButtonElement>(ref)}
                  aria-label="Show more items"
                  className={cx(tooltipProps.className)}
                  variant="secondary"
                  size="small"
                  endIcon={ChevronDown}
                  withTextEllipsis
                >
                  {moreTagsTooltip}
                </Button>
              )}
            >
              Show more spaces
            </Tooltip>
          }
        >
          {items.map((item, i) => (
            <DropdownMenuItem key={i} href={`/spaces/${item.id}`}>
              <TableCellSpace href={`/spaces/${item.id}`}>{item.name}</TableCellSpace>
            </DropdownMenuItem>
          ))}
        </DropdownMenu>
      </Box>
    </TableSimpleCell>
  );
};

export default SharedModulesTableSharedToCell;
